/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { FC, useState, useContext } from "react";
import { createUseStyles, useTheme } from "react-jss";

import Info from "Assets/images/info.svg";
import { motion } from "framer-motion";

import ShareMenuContainer from "Containers/ShareMenu";
import { MapContext } from "Context/MapContext";
import { sanitize } from "dompurify";
import styles from "./styles";

interface Props {
  media: any[];
  selectedIdx: number;
}

export const getAwsVideoUrl = (selectedVideo: any) => {
  return `https://video${selectedVideo.url.split("video")[1]}`;
};

export const getVimeoVideoUrl = (selectedVideo: any) => {
  return `https://player.vimeo.com/video/${selectedVideo.videoid}?embedparameter=value`;
};

export const getYoutubeVideoUrl = (selectedVideo: any) => {
  return `https://www.youtube-nocookie.com/embed/${selectedVideo.videoid}?controls=true&amp;showinfo=0&amp;wmode=transparent&amp;loop=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fyouvisit.com&amp;widgetid=3&amp;modestbranding=1`;
};

const Videoviewer: FC<Props> = (props: Props) => {
  const useStyles = createUseStyles(styles);

  const [info, showInfo] = useState(false);

  const theme = useTheme();

  const classes = useStyles({ theme, ...props, state: { info } });
  const { media, selectedIdx } = props;
  const { type } = media[selectedIdx];
  const { instId, locId } = useContext(MapContext);

  const shareUrl = `${process.env.REACT_APP_API_BASE_URL}tour/videos/${instId}/${locId}?id=${media[selectedIdx]?.id}`;
  const animations = {
    open: {
      x: "0%",
      transition: {
        ease: [0.28, 0.57, 0.2, 1],
        duration: 0.5,
      },
    },
    closed: {
      x: "100%",
      transition: {
        ease: "easeIn",
        duration: 0.25,
      },
    },
  };

  const getVideo = (videoType: string) => {
    let url: string;
    switch (videoType) {
      case "aws":
        url = getAwsVideoUrl(media[selectedIdx]);
        // eslint-disable-next-line jsx-a11y/media-has-caption
        return <video className={classes.awsVideo} controls src={url} />;
      case "vimeo":
        url = getVimeoVideoUrl(media[selectedIdx]);
        return <iframe src={url} title="Video Player" frameBorder="0" />;
      case "campusreel":
      case "youtube":
        url =
          videoType === "campusreel"
            ? media[selectedIdx].url || media[selectedIdx].videoid
            : getYoutubeVideoUrl(media[selectedIdx]);
        return (
          <iframe
            tabIndex={0}
            id="video_2"
            className="video-player"
            frameBorder="0"
            allowFullScreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            title="YouTube video player"
            width={`${info ? "1009" : "1056"}px`}
            height="683px"
            src={url}
            data-testid="video"
          />
        );
      default:
        return <div>Video Type Not Found</div>;
    }
  };

  return (
    <>
      <div className={classes.videoContainer} data-testid="video">
        {!info && (
          <div
            id="carousel-title"
            className={classes.title}
            data-testid="title"
            tabIndex={0}
            onBlur={() => {
              document.getElementById(`video_2`).focus();
            }}
          >
            {media[selectedIdx].title}
          </div>
        )}
        {getVideo(type)}
        <div className={classes.infoPanel}>
          {media[selectedIdx].description && (
            <button
              type="button"
              aria-label="Open Description"
              className={classes.info}
              onClick={() => showInfo(!info)}
              tabIndex={0}
              data-testid="info"
              onBlur={() => {
                !info &&
                  document
                    .getElementById(`carouselImages-${selectedIdx + 1}`)
                    .focus();
              }}
            >
              <Info />
            </button>
          )}
          {info && (
            <motion.div
              initial={{ x: "100%" }}
              animate={info ? "open" : "closed"}
              variants={animations}
              className={classes.infoPanel}
            >
              <div
                className={classes.description}
                data-testid="description"
                tabIndex={0}
                id="carousel-description"
                dangerouslySetInnerHTML={{
                  __html: sanitize(media[selectedIdx].description, {
                    ADD_ATTR: ["target"],
                  }),
                }}
                onBlur={() => {
                  showInfo(!info);
                  document
                    .getElementById(`carouselImages-${selectedIdx + 1}`)
                    .focus();
                }}
              />
            </motion.div>
          )}
        </div>
        {shareUrl && (
          <div tabIndex={-1} aria-hidden="true" className={classes.shareMenu}>
            {!info && (
              <span
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  bottom: "0%",
                  right: "0%",
                }}
              >
                <ShareMenuContainer
                  url={shareUrl}
                  className={classes.shareMenu}
                  svgColor="#FFFFFF"
                />
              </span>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Videoviewer;
